import { cloneElement, useEffect } from 'react';

import { useRouterContext } from '../router/context';
import { findRouterByName } from '../../helpers/find-router-by-name';

import type { IProps } from './models';

/** Компонент, который переключает роут */
export const Switcher = <S,>({ children, route, router, trigger = 'onClick' }: IProps<S>) => {
    const currentRouter = useRouterContext<S>();

    const handleTrigger = () => {
        if (!router) return currentRouter.switchRoute(route);

        const foundRouter = findRouterByName<S>(currentRouter, router);
        foundRouter?.switchRoute(route);
    };

    useEffect(() => {
        if (!children) handleTrigger();

        // выполняется только на монтирование
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (!children) return null;

    return cloneElement(children, {
        [trigger]: () => handleTrigger(),
    });
};
